import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {AppController} from "../app/app-controller";
import {APP, PUSH_NOTIFICATIONS_PERMISSIONS} from "../app/consts";
import {ACTION_TYPES, LOCAL_STORAGE_KEYS} from "../consts";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";

export class PushNotificationsRequestPermissionHandler extends ActionHandler {
  controller: AppController;
  localStorageUtils: LocalStorageUtils;
  type = APP.ACTION_TYPES.pushNotificationsRequestPermissionHandler;

  static injectables = [...ActionHandler.injectables, LocalStorageUtils];

  constructor(localStorageUtils: LocalStorageUtils) {
    super();

    this.localStorageUtils = localStorageUtils;
  }

  async action(params) {
    if (Notification?.permission === PUSH_NOTIFICATIONS_PERMISSIONS.default) {
      const countDisplayBrowserMessage: Number = (this.localStorageUtils.get(LOCAL_STORAGE_KEYS.countNotificationBrowserMessageDisplays) || 0) + 1;
      this.localStorageUtils.set(LOCAL_STORAGE_KEYS.countNotificationBrowserMessageDisplays, countDisplayBrowserMessage)

      this.sendBrowserDisplayEvent(params?.trigger, countDisplayBrowserMessage);

      await Notification.requestPermission((permission: PUSH_NOTIFICATIONS_PERMISSIONS) => {
        if (permission === PUSH_NOTIFICATIONS_PERMISSIONS.granted) {
          this.appStore.state.userAllowedNotification = true;
          this.appStore.state.enableNotifications = true;
          this.sendBrowserClickEvent(params?.trigger, countDisplayBrowserMessage, APP.ANALYTICS.NOTIFICATIONS.CLICK_TYPE.allow)
        } else if (permission === PUSH_NOTIFICATIONS_PERMISSIONS.denied) {
          this.controller.action(ACTION_TYPES.notificationSecondNoticeDisplay, {isVisible: true})
          this.appStore.state.userAllowedNotification = false;
          this.appStore.state.enableNotifications = false;
          this.sendBrowserClickEvent(params?.trigger, countDisplayBrowserMessage, APP.ANALYTICS.NOTIFICATIONS.CLICK_TYPE.deny)
        } else {
          this.sendBrowserClickEvent(params?.trigger, countDisplayBrowserMessage, APP.ANALYTICS.NOTIFICATIONS.CLICK_TYPE.close);
          this.appStore.state.enableNotifications = false;
        }
      });

      this.controller.action(APP.ACTION_TYPES.fetchUsers);
    }
  }

  sendBrowserDisplayEvent(trigger: String, countDisplayBrowserMessage: Number) {
    this.controller.action(ACTION_TYPES.notificationsPermissionDisplay, {
      type: APP.ANALYTICS.NOTIFICATIONS.TYPES.browser,
      trigger: trigger,
      numShown: countDisplayBrowserMessage,
    });
  }

  sendBrowserClickEvent(trigger: String, countDisplayBrowserMessage: Number, clickType: String) {
    this.controller.action(ACTION_TYPES.notificationsPermissionClick, {
      type: APP.ANALYTICS.NOTIFICATIONS.TYPES.browser,
      trigger: trigger,
      numShown: countDisplayBrowserMessage,
      clickType: clickType
    });
  }
}
